module.exports = __webpack_public_path__ + "889c8e93f1ed1a97d9215d3caf979f9c.pdf";